import renderButton from '!pug-loader!./button.pug'
import renderInput from '!pug-loader!./input.pug'
import i18n from '../../../i18n'

t = (key) -> i18n.t("javascript.editor.actions.html_templates.#{key}")

export default ->
  button:
    name: t('button.name')
    render: renderButton
    domIdFields:
      buttonId:
        type: "button"
        conditionNameField: "buttonText"
    form:
      buttonId: t('button.button_id')
      backgroudAssetId: t('button.background_asset_id')
      text: t('button.text')
      buttonText: t('button.button_text')

  input:
    name: t('input.name')
    render: renderInput
    domIdFields:
      inputId:
        type: "input"
        conditionNameField: "placeholder"
      buttonId:
        type: 'button'
        conditionNameField: "buttonText"
    form:
      backgroudAssetId: t('input.background_asset_id')
      text: t('input.text')
      placeholder: t('input.placeholder')
      buttonText: t('input.button_text')
      inputId: t('input.input_id')
      buttonId: t('input.button_id')
